import React from "react";
import useRFIs from "../../../hooks/useRFIs";
import RfiTable from "../../../stories/Components/RfiTable/RfiTable";

const RfiList = () => {
  const {
    data: { rfis = [] },
  } = useRFIs();

  return <RfiTable data={rfis} />;
};

export default RfiList;
